import React from 'react';
import { CapitalizeNames } from 'src/utils/capitalize';
import { EnchancedModal } from 'src/components/Modals';
import type { TMultimediaPreview } from 'src/views/OmniChannel/utils/outboundMultimedia';
import { MultimediaPreviewContent } from './MultimediaPreviewContent';

type TOutboundMultimediaPreviewModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    preview: TMultimediaPreview | null;
};

export const OutboundMultimediaPreviewModal = ({
    open,
    setOpen,
    preview,
}: TOutboundMultimediaPreviewModalProps) => {
    if (!preview) return null;

    return (
        <EnchancedModal
            open={open}
            setOpen={setOpen}
            title={CapitalizeNames(preview.name)}
            maxWidth="lg"
        >
            <MultimediaPreviewContent
                source={preview.source}
                name={preview.name}
                contentType={preview.contentType}
                variant="modal"
            />
        </EnchancedModal>
    );
};
